module.exports = __webpack_public_path__ + "img/trip_16.edc9e142.jpg";